import { BluTextField } from '@bludata/components';
import { Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import { memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

interface TelephoneInterface {
  isTabClienti: boolean;
}

export const Telephone: FC<TelephoneInterface> = memo(({ isTabClienti }) => {
  const telephone = useWatch({ name: 'telephone' });
  const { setValue, trigger } = useFormContext();
  return (
    <Stack flex="1">
      <Typography variant="subtitle2" sx={{ pt: '3px' }}>
        Telefono
      </Typography>
      <BluTextField
        value={telephone}
        name="Telefono"
        autoComplete="off" // Disabilita il completamento automatico
        onChange={(
          event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
        ) => {
          setValue('telephone', event.target.value);
          trigger();
        }}
      />
    </Stack>
  );
});
